import { STATUS_CREATED, STATUS_CREATED_CODE } from "../constants/constant";
import { DragChangeSizes, DragDropOption, DragItemSize, IGridUseData, SizeChangeData } from "./interface";

/**
 * 设置定位
 * @param width 单个网格宽度
 * @param height 单个网格高度
 * @param itemSize 
 * @returns 
 */
export function setDragPosition(width: number, height: number, itemSize: DragItemSize) {
  const { left, top, column, row, } = itemSize;
  // return {
  //   left: ((left + 1) * 8) + (left * width),
  //   top: ((top + 1) * 8) + (top * height),
  //   width: ((column - 1) * 8) + (column * width),
  //   height: ((row - 1) * 8) + (row * height),
  // };
  return {
    left: left * (width + 8),
    top: top * (height + 8),
    width: ((column - 1) * 8) + (column * width),
    height: ((row - 1) * 8) + (row * height),
  };
}
/**
 * 获取移动结束后的定位信息
 * @param width 单个网格宽度
 * @param height 单个网格高度
 * @param column 列占用网格数
 * @param left left网格当前定位
 * @param top top网格当前定位
 * @returns 
 */
export function getMovePosition(width: number, height: number, column: number, left: number, top: number) {
  const newLeft = Math.round(left / (width + 8));
  const newTop = Math.round(top / (height + 8));
  return {
    left: (newLeft + column) > 12 ? (12 - column) : (newLeft < 0 ? 0 : newLeft),
    top: newTop > 0 ? newTop : 0,
  };
}
/**
 * 获取有效的top偏移
 */
export function getChangeTop(params: DragChangeSizes): number {
  const { moveY, height, top, row, minRow = 1, } = params;
  const effective = moveY < 0 ? Math.min(moveY + 8, 0) : moveY;
  const moveTop = Math.floor(effective / (height + 8));
  if (moveTop < 0) {
    const difTop = top + moveTop;
    return difTop < 0 ? - top : moveTop;
  }
  if (moveTop > 0) {
    const difTop = row - moveTop;
    return difTop < minRow ? row - minRow : moveTop;
  }
  return moveTop;
}
/**
 * 获取有效的column偏移
 */
export function getChangeRight(params: DragChangeSizes): number {
  const { moveX, width, column, left, grid, minColumn = 1, } = params;
  const effective = moveX > 0 ? Math.max(moveX - 8, 0) : moveX;
  const moveColumn = Math.ceil(effective / (width + 8));
  if (moveColumn < 0) {
    const difColumn = column + moveColumn;
    return difColumn < minColumn ? -(column - minColumn) : moveColumn;
  }
  if (moveColumn > 0) {
    const difColumn = left + column + moveColumn;
    return difColumn > grid ? grid - column - left : moveColumn;
  }
  return moveColumn;
}
/**
 * 获取有效的row偏移量
 */
export function getChangeBottom(params: DragChangeSizes): number {
  const { moveY, height, row, minRow = 1, } = params;
  const effective = moveY > 0 ? Math.max(moveY - 8, 0) : moveY;
  const moveRow = Math.ceil(effective / (height + 8));
  if (moveRow < 0) {
    const difRow = row + moveRow;
    return difRow < minRow ? -(row - minRow) : moveRow;
  }
  return moveRow;
}
/**
 * 获取有效的left偏移量
 */
export function getChangeLeft(params: DragChangeSizes): number {
  const { moveX, width, left, column, minColumn = 1,} = params;
  const effective = moveX < 0 ? Math.min(moveX + 8, 0) : moveX;
  const moveLeft = Math.floor(effective / (width + 8));
  if (moveLeft < 0) {
    const difLeft = left + moveLeft;
    return difLeft < 0 ? -left : moveLeft;
  }
  if (moveLeft > 0) {
    const difLeft = column - moveLeft;
    return difLeft < minColumn ? column - minColumn : moveLeft;
  }
  return moveLeft;
}
/**
 * 偏移后容器信息
 * @param data 偏移量
 * @param itemSize 偏移前容器信息
 * @returns 
 */
export function getChangeSize(data: SizeChangeData, itemSize: DragItemSize): DragItemSize {
  const { left: deviationLeft, top: deviationTop, column: deviationColumn, row: deviationRow, } = data;
  const { left, top, column, row, } = itemSize;
  const newLeft = Math.max(left + deviationLeft, 0);
  const newTop = Math.max(top + deviationTop, 0);
  const newColumn = Math.max(column + deviationColumn, 0);
  const newRow = Math.max(row + deviationRow, 0);
  return {
    left: newLeft,
    top: newTop,
    column: newColumn,
    row: newRow,
  }
}
/**
 * 判断拖动后是否有重合
 * @param changeItem 拖动项拖动后配置
 * @param dragItems 拖动项集合
 * @returns 
 */
export function checkCoincidence(changeItem: DragDropOption, dragItems: DragDropOption[]): boolean {
  const { name, left = 0, top = 0, column = 1, row = 1, } = changeItem;
  /** 移动项最小left */
  const minLeft = left;
  /** 移动项最大left */
  const maxLeft = left + column;
  /** 移动项最小top */
  const minTop = top;
  /** 移动项最大top */
  const maxTop = top + row;
  const itemLength = dragItems.length;
  for (let index = 0; index < itemLength; index++) {
    const targetItem = dragItems[index];
    if (name === targetItem.name) continue;
    const { left: targetLeft = 0, top: targetTop = 0, column: targetColumn = 1, row: targetRow = 1, } = targetItem;
    // 大小完全一致，位置对换
    if (left === targetLeft && top === targetTop && column === targetColumn && row === targetRow) {
      return false;
    }
    /** 目标项最小left */
    const minTargetLeft = targetLeft;
    /** 目标项最大left */
    const maxTargetLeft = targetLeft + targetColumn;
    /** 目标项最小top */
    const minTargetTop = targetTop;
    /** 目标项最大top */
    const maxTargetTop = targetTop + targetRow;
    /** x轴是否重合 */
    const xCoincidence = (minLeft >= minTargetLeft && minLeft < maxTargetLeft) || (maxLeft > minTargetLeft && maxLeft <= maxTargetLeft);
    /** y轴是否重合 */
    const yCoincidence = (minTop >= minTargetTop && minTop < maxTargetTop) || (maxTop > minTargetTop && maxTop <= maxTargetTop);
    if (xCoincidence && yCoincidence) return true;
  }
  return false;
}
/**
 * 获取网格占用情况
 * @param dragItems 拖拽项配置 
 * @returns 
 */
export function getGridUseData(dragItems?: DragDropOption[]): IGridUseData[] {
  const gridUse: number[][] = [];
  const gridUseData: IGridUseData[] = [];
  const effectiveDragItems = dragItems?.filter(item => item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE);
  effectiveDragItems?.forEach(item => {
    const { left = 0, top = 0, row = 1, column = 1, } = item;
    for (let rowIndex = top; rowIndex < (top + row); rowIndex++) {
      if (!gridUse[rowIndex]) gridUse[rowIndex] = [];
      for (let columnIdex = left; columnIdex < (left + column); columnIdex++) {
        if (!gridUse[rowIndex].includes(columnIdex)) {
          gridUse[rowIndex].push(columnIdex);
        }
      }
    }
  });
  for (let [key, value] of Object.entries(gridUse)) {
    gridUseData.push({
      row: Number(key),
      columns: value.sort(),
    });
  }
  return gridUseData;
}
/**
 * 生成满足插入项的定位
 * @param addDragItem 插入项配置
 * @param gridUseData 网格占用情况
 * @param grid 网格数
 * @returns 
 */
export function getAddChange(addDragItem: DragDropOption, gridUseData: IGridUseData[], grid: number) {
  const { row = 1, column = 1, } = addDragItem;
  /** 被占用的最大行 */
  const laseRow = gridUseData.length ? gridUseData[gridUseData.length - 1].row : 0;
  /** 添加后可能出现的最大行 */
  const maxRow = laseRow + row;
  /** 连续满足插入条件的行数 */
  let effectiveCount: number = 0;
  for (let rowIndex = 0; rowIndex < maxRow; rowIndex++) {
    const findItem = gridUseData.find(item => item.row === rowIndex);
    /** 当前行的占用情况 */
    const useColumns = findItem?.columns || [];
    // 当前可插入的网格数小于新增项要占用的网格数 重置并退出循环
    if ((grid - useColumns.length) < column) {
      effectiveCount = 0
      continue;
    }
    /** 查找当前行满足插入条件的列 */
    for (let columnIndex = 0; columnIndex <= (grid - column); columnIndex++) {
      const flag = satisfyColumn(columnIndex, grid, column, useColumns);
      if (flag) {
        effectiveCount = effectiveCount + 1;
        if (effectiveCount === row) {
          return {
            left: columnIndex,
            top: rowIndex,
          };
        }
        /** 当前行满足插入条件的列在其他行是否也满足 */
        for (let index = 1; index < row; index++) {
          const nextFindItem = gridUseData.find(item => item.row === (rowIndex + index));
          /** 下一行的占用情况 */
          const nextUseColumns = nextFindItem?.columns || [];
          const nextFlag = satisfyColumn(columnIndex, grid, column, nextUseColumns);
          if (nextFlag) {
            effectiveCount = effectiveCount + 1;
            if (effectiveCount === row) {
              return {
                left: columnIndex,
                top: rowIndex,
              };
            }
          } else {
            effectiveCount = 0
            break;
          }
        }
        continue;
      } else {
        effectiveCount = 0
        continue;
      }
    }
  }
  return {
    left: 0,
    top: laseRow + 1,
  };
}
/**
 * 是否可以插入当前行
 * @param currentColumn 当前行数
 * @param grid 网格数
 * @param column 插入项列宽
 * @param useColumns 当前列占用情况
 * @returns 
 */
function satisfyColumn(currentColumn: number, grid: number, column: number, useColumns: number[]): boolean {
  if (!useColumns || !useColumns.length) return true;
  /** 连续满足插入条件的列数 */
  let effectiveCount: number = 0;
  for (let index = currentColumn; index <= grid; index++) {
    const flag = !useColumns.includes(index);
    if (flag) {
      effectiveCount = effectiveCount + 1;
      if (effectiveCount === column) {
        return true;
      }
    } else {
      return false;
    }
  }
  return false;
}
/** 验证改变大小后是否会出现重合情况 */
export function checkChangeSize(changeCofig: DragDropOption, otherGridUseData: IGridUseData[], grid: number) {
  const changeGridData: IGridUseData[] = getGridUseData([changeCofig]);
  for (let index = 0; index < changeGridData.length; index++) {
    const element = changeGridData[index];
    const { row, columns } = element;
    const findItem = otherGridUseData.find(item => item.row === row);
    if (findItem) {
      const { columns: useColumns } = findItem;
      if (columns.length + useColumns.length > grid) return true;
      for (let k = 0; k < columns.length; k++) {
        const targetColumn = columns[k];
        if (useColumns.includes(targetColumn)) return true;
      }
    }
  }
  return false;
};
/**
 * 将初始化的dragItems
 * @param dragItems 
 * @param grid 
 * @returns 
 */
export function getInitOption(dragItems: DragDropOption[], grid: number): DragDropOption[] {
  const newDragItems: DragDropOption[] = [];
  let newGridUseData: IGridUseData[] = [];
  if (Array.isArray(dragItems) && dragItems.length) {
    const apiCopyOptions: DragDropOption[] = [];
    dragItems.forEach(item => {
      if (item.isApiCopy) {
        apiCopyOptions.push(item);
      } else {
        newDragItems.push(item);
      }
    });
    if (Array.isArray(apiCopyOptions) && apiCopyOptions.length) {
      apiCopyOptions.forEach(item => {
        newGridUseData = getGridUseData(newDragItems);
        const addInfo = getAddChange(item, newGridUseData, grid);
        newDragItems.push({ ...item, ...addInfo, });
      });
    }
  }
  return newDragItems;
}
